import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=4d56913b&"
import script from "./RequestsPage.vue?vue&type=script&lang=js&"
export * from "./RequestsPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports